import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { UserService } from '../services/user/user.service';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../store/store.model';
import OFFERS_ACTIONS from '../store/offers/offers.actions';

@Injectable({
	providedIn: 'root',
})
export class InitUserGuard implements CanActivate {
	private readonly router = inject(Router);
	private readonly store = inject(Store<IvvaStore>);
	private readonly userService = inject(UserService);

	canActivate(): Observable<boolean> {
		return this.userService.getUser().pipe(
			map((user) => {
				this.store.next(OFFERS_ACTIONS.setUser({ user }));
				return true;
			})
		);
	}
}
